import { render, staticRenderFns } from "./Total-sensors.vue?vue&type=template&id=3fb8ce72"
import script from "./Total-sensors.vue?vue&type=script&lang=js"
export * from "./Total-sensors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports